/* global angular */
(function () {
  'use strict';

  angular.module('wsLrs.directives').directive('pickerPill', ['$interpolate', function ($interpolate) {
    return {
      scope: {
        item: '<',
        popoverHtml: '<?',
        // {string} Displayed when hovered over the picker pill,
        interpolatePopoverHtml: '<?' // ({item}) => HtmlElement
      },
      replace: true,
      templateUrl: 'modules/common/directives/picker/picker-pill.html',
      link: function link(scope) {
        if (typeof scope.interpolatePopoverHtml === 'function') {
          scope.popoverHtml = scope.interpolatePopoverHtml(scope);
        }
        if (!scope.popoverHtml) {
          scope.popoverHtml = $interpolate("<span>{{item.name}}<br>{{item.activityId || item.verbId || item.id}}{{item.personas[0] | personaDisplay}}</span>")(scope);
        }
      }
    };
  }]);
})();
